module.exports = __webpack_public_path__ + "img/05_bastien-nvs.d83a1f06.jpg";